import { __assign } from "tslib";
import * as React from 'react';
var MarkdownImpl = React.lazy(function () { return import('../../internal/MarkdownImpl'); });
/**
 * Lazy loads a markdown renderer using markdown-it.
 */
export var Markdown = function (props) { return React.createElement(MarkdownImpl, __assign({}, props)); };
//# sourceMappingURL=index.js.map